import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'snakeCase',
    standalone: true,
})
export class SnakeCasePipe implements PipeTransform {
    public transform(input: string, condition?: boolean): string {
        if (!input) return 'N/A';

        if (condition) return 'N/A';

        const result = input
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

        return result;
    }
}
